/* eslint-disable camelcase */
import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { ImageService } from '~/services/Misc/ImageService'

interface TagItem {
  id: number
  name: string
}

export class AccountVacancyModel extends BaseModel {
  id: number = 0
  address: string = ''
  conditions: string = ''
  education: string = ''
  education_value: string = ''
  employment: string = ''
  employment_value: string = ''
  experience: string = ''
  experience_value: string = ''
  foreign_worker: boolean = false
  housing: number = 0
  housing_value: string = ''
  import_org_name: string = ''
  import_org_url: string = ''
  import_source_id: string | number | null = null
  import_source_name: string = ''
  import_vacancy_url: string = ''
  organization: number = 0
  organization_value: string = ''
  'company_logo': string = ''
  position: string | null = null
  position_value: string | null = null
  position_name: string | null = null
  published: string = ''
  region: string = ''
  region_value: string = ''
  'vacancy_region_id': number | null = null
  requirements: string = ''
  responsibilities: string = ''
  salary: number | null = null
  schedule: string = ''
  status: string = ''
  status_value: string = ''
  suspicious: number = 0
  suspicious_value: string = ''
  updated: string = ''
  workplace: string = ''
  workplace_value: string = ''
  is_deleted: boolean = false
  is_vacancy_promotion: boolean = false
  is_vacancy_company_promotion: boolean = false
  is_accept_handicapped: boolean = false
  'is_salary_hidden': boolean = false
  'is_simple_feedback': boolean = false
  vacancy_source_code: string = ''
  company_description: string = ''
  'internship_start_date': string = ''
  'internship_end_date': string = ''
  'internship_image': File | string | null = null
  'internship_priority': TagItem[] = []
  internship_priority_values: string[] = []
  internship_expectation_values: string[] = []
  'employment_format_values': string[] = []
  'employment_format_ids': number[] = []
  'career_direction_values': string[] = []
  'career_direction_ids': number[] = []
  'internship_expectation_ids': number[] = []
  'internship_priority_ids': number[] = []

  constructor(data: unknown) {
    super()

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (typeof data.salary === 'string') {
        this.salary = Number(data.salary)
      }

      if (typeof data.import_source_id === 'string' || typeof data.import_source_id === 'number') {
        this.import_source_id = data.import_source_id
      }

      if (typeof data.foreign_worker === 'number') {
        this.foreign_worker = Boolean(data.foreign_worker)
      }

      if (typeof data.is_deleted === 'number') {
        this.is_deleted = Boolean(data.is_deleted)
      }

      if (data.internship_image) {
        this.internship_image = new ImageService().cropImage(data.internship_image, {})
      }

      if (data.company_logo) {
        this.company_logo = new ImageService().cropImage(data.company_logo, {})
      }
    }
  }
}
